import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=5d00bf78&scoped=true&"
import script from "./StudentView.vue?vue&type=script&lang=js&"
export * from "./StudentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d00bf78",
  null
  
)

export default component.exports